import {
    resolveTeamDashboardViewBy,
    TEAM_DASHBOARD_VIEW_BY_DEFAULT,
} from "./teamDashboardViewBy.js";

const STORAGE_KEY = "kfu_team_dashboard_view_by";

function readMap() {
    if (typeof localStorage === "undefined") return {};
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : {};
    } catch {
        return {};
    }
}

function writeMap(map) {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map ?? {}));
}

function resolveProfileId(userProfileId) {
    if (userProfileId != null && userProfileId !== "") {
        return String(userProfileId);
    }
    if (typeof localStorage === "undefined") return null;
    try {
        const fromStorage = localStorage.getItem("kaamfu_profile_id");
        return fromStorage ? String(fromStorage) : null;
    } catch {
        return null;
    }
}

export function readTeamDashboardViewByFromStorage(userProfileId) {
    const profile_id = resolveProfileId(userProfileId);
    if (!profile_id) return undefined;

    const map = readMap();
    if (!Object.prototype.hasOwnProperty.call(map, profile_id)) return undefined;

    return resolveTeamDashboardViewBy(map[profile_id]);
}

export function writeTeamDashboardViewByToStorage(userProfileId, viewBy) {
    const profile_id = resolveProfileId(userProfileId);
    if (!profile_id) return;

    const map = readMap();
    map[profile_id] = resolveTeamDashboardViewBy(viewBy) ?? TEAM_DASHBOARD_VIEW_BY_DEFAULT;
    writeMap(map);
}

/** Local value wins on reload, same precedence as section-fullscreen hydration. */
export function hydrateTeamDashboardViewBy(userProfileId, serverValue) {
    const stored = readTeamDashboardViewByFromStorage(userProfileId);
    if (stored !== undefined) return stored;

    return resolveTeamDashboardViewBy(serverValue);
}